import { useCallback } from 'react';

import { Stop } from '../../../../../domain/stop/Stop';
import { intercom, INTERCOM_EVENTS } from '../../../../../services/intercom';
import { PlanDetailsMap } from '../../plan-details-map';

interface PlanOverviewMapProps {
  focusedStop?: Stop;
  setFocusedStop: (focusedStop?: Stop) => void;
}

export const PlanOverviewMap = ({ focusedStop, setFocusedStop }: PlanOverviewMapProps) => {
  const contextualMenuOpen = useCallback(() => {
    intercom.track(INTERCOM_EVENTS.plan.overview.map.contextual_clicked);
  }, []);

  return (
    <div
      style={{
        backgroundColor: `white`,
        width: `calc(100% - 380px)`,
        height: `calc(100vh - 46px)`, //38 px of height plus +4+4 of floating design
      }}
    >
      <PlanDetailsMap
        focusedStop={focusedStop}
        setFocusedStop={setFocusedStop}
        contextualMenuOpen={contextualMenuOpen}
      />
    </div>
  );
};
